import React from 'react';

const Loader = (props) => {
    if (props.useFullSize) {
        return <div className="loader loader--full-size"></div>;
    }
    return <div className="loader"></div>;
};

export default Loader;


